"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTION_VERSION_TX_HASH_SIGN = exports.TRANSACTION_VERSION_DEFAULT = exports.TRANSACTION_OPTIONS_TX_HASH_SIGN = exports.TRANSACTION_OPTIONS_DEFAULT = void 0;
exports.TRANSACTION_OPTIONS_DEFAULT = 0;
exports.TRANSACTION_OPTIONS_TX_HASH_SIGN = 1;
exports.TRANSACTION_VERSION_DEFAULT = 1;
exports.TRANSACTION_VERSION_TX_HASH_SIGN = 2;
//# sourceMappingURL=constants.js.map